export default "https://cdn-static.gokick.com/assets/e732fce3df71ad981aa0ee65436659b369042414/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";